import "./style.css";
import { GameSdk } from "../sdk/index.ts";
import type { GameSession } from "../sdk/index.ts";
import type { ErrorInfo } from "../shared/model.ts";
const app = document.querySelector<HTMLElement>("#app")!;
let session: GameSession | null = null,
  sdk = new GameSdk(),
  profile: { userId: string; name: string } | null = null;
const escape = (text: unknown) =>
  String(text ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ]!,
  );
const logo = `<span class="brand-ball"><span>8</span></span><span class="brand-word">CUE CLUB<small>美式 8 球</small></span>`;
function toast(text: string) {
  let el = document.querySelector<HTMLElement>(".toast");
  if (!el) {
    el = document.createElement("div");
    el.className = "toast";
    document.body.append(el);
  }
  el.textContent = text;
  el.classList.add("show");
  setTimeout(() => el?.classList.remove("show"), 3600);
}
async function api(path: string, body?: unknown) {
  const r = await fetch(path, {
    method: body ? "POST" : "GET",
    credentials: "include",
    ...(body
      ? {
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      : {}),
  });
  const result = await r.json();
  if (!result.ok) throw result.error;
  return result.data;
}
function errorText(e: unknown) {
  return (e as ErrorInfo)?.message ?? "连接出现问题，请重试";
}

async function enter() {
  app.innerHTML = `<div class="loading-screen">${logo}<p>正在准备球桌…</p></div>`;
  try {
    const config = await api("/v1/config");
    await sdk.init({
      appId: config.appId,
      environment: "test",
      apiBaseUrl: config.apiBaseUrl ?? location.origin,
      manifestPublicKey: config.manifestPublicKey,
    });
    const loaded = await sdk.loadGame({
      gameId: "eightball",
      userId: profile!.userId,
      locale: "zh-CN",
      viewport: {
        width: innerWidth,
        height: innerHeight,
        pixelRatio: devicePixelRatio,
        safeInsets: { top: 0, left: 0, right: 0, bottom: 0 },
      },
      ui: {
        soundEnabled: true,
        musicEnabled: false,
        hapticsEnabled: false,
        hostControls: [],
      },
      getCode: () => api("/v1/host/game-code", { gameId: "eightball" }),
      displayName: profile!.name,
      onEvent: (e) => {
        if (e.name === "host.actionRequested")
          void session?.resolveHostAction(e.payload.actionId, "ALLOW");
      },
    });
    if (!loaded.ok) throw loaded.error;
    session = loaded.data;
    app.replaceChildren(session.getView());
    const params = new URLSearchParams(location.search);
    if (params.has("room") && params.has("invite"))
      await session.perform({
        requestId: crypto.randomUUID(),
        name: "room.join",
        payload: {
          roomId: params.get("room"),
          inviteToken: params.get("invite"),
        },
      });
  } catch (e) {
    app.innerHTML = `<div class="login-screen"><div class="brand">${logo}</div><h1>球桌暂未就绪</h1><p>${escape(errorText(e))}</p><button class="button primary" id="retry">重新连接</button></div>`;
    document.querySelector("#retry")!.addEventListener("click", () => {
      void sdk.uninit().then(enter);
    });
  }
}
function login() {
  app.innerHTML = `<div class="login-screen"><a class="brand">${logo}</a><div class="eyebrow">WELCOME TO THE CLUB</div><h1>来一局？</h1><p>给自己起个球桌昵称，开始你的第一局。</p><form id="login"><label for="name">球桌昵称</label><input id="name" name="name" maxlength="24" placeholder="例如：一杆清台" autocomplete="nickname" required><button class="button primary" type="submit">进入球房 ↗</button></form><span class="login-caption">专注每一杆，享受每一局。</span></div>`;
  document.querySelector<HTMLFormElement>("#login")!.onsubmit = async (e) => {
    e.preventDefault();
    try {
      profile = await api("/dev/login", {
        name: (document.querySelector("#name") as HTMLInputElement).value,
      });
      await enter();
    } catch (error) {
      toast(errorText(error));
    }
  };
}
void api("/dev/profile")
  .then((user) => {
    profile = user;
    if (profile) void enter();
    else login();
  })
  .catch(() => login());
document.addEventListener("visibilitychange", () => {
  void session?.setForeground(!document.hidden);
});
window.addEventListener("resize", () => {
  void session?.updateViewport({
    width: innerWidth,
    height: innerHeight,
    pixelRatio: devicePixelRatio,
    safeInsets: { top: 0, left: 0, right: 0, bottom: 0 },
  });
});
window.addEventListener("pagehide", () => {
  void session?.destroy();
});
